<!-- Content -->
<div class="flex flex-1 overflow-auto justify-content-center">
  <!-- Form -->
  @if (vocabularyWordForm) {
    <medsurf-design-form-control-form
      [formGroup]="vocabularyWordForm"
      [class]="'w-full'"
      (onSubmit)="onSubmit()">
      <!-- Vocabulary Word Key -->
      <medsurf-design-form-control-input-text #keyInputText
        [control]="vocabularyWordForm.controls.key"
      [label]="'global.key'"></medsurf-design-form-control-input-text>
      <!-- Vocabulary Word Value -->
      <medsurf-design-form-control-input-text [control]="vocabularyWordForm.controls.value"
      [label]="'global.value'"></medsurf-design-form-control-input-text>
      <div class="flex flex-row column-gap-2">
        <!-- Submit -->
        <medsurf-design-form-control-input-submit [formField]="false"
        [label]="'global.save_changes'"></medsurf-design-form-control-input-submit>
        <!-- Delete -->
        @if (!isNew()) {
          <button medsurf-design-input-button
            [id]="'vocabulary_word_remove'"
            [label]="'global.vocabulary_word_remove' | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
          (click)="deleteVocabularyWord()"></button>
        }
      </div>
    </medsurf-design-form-control-form>
  }
</div>
